var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "neopassindex"
    }
  }, [_c('add-new-neopass-popup', {
    attrs: {
      "add-neopass-display": _vm.addNeopassDisplay
    },
    on: {
      "close": function ($event) {
        _vm.addNeopassDisplay = -1;
      },
      "open": _vm.openPopupNewNeopass,
      "changeStep": function (numStep) {
        _vm.addNeopassDisplay = numStep;
      }
    }
  }), _vm._v(" "), _c('edit-beneficiary-rights-popup', {
    attrs: {
      "is-displayed": _vm.isPopupEditBeneficiaryRightsDisplayed,
      "message-header": _vm.messageHeader,
      "message-save-success": "Les droits du bénéficiaire ont bien été enregistrés.",
      "saving": _vm.saving,
      "list-modules-pages": _vm.listNeopassModulesPages,
      "permissions": _vm.permissions,
      "neopass-form-rights": ((_vm.beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateEditBeneficiaryRightsPopup(false);
      },
      "saveRights": _vm.save_beneficiary_rights,
      "check": function (options) {
        if (options.page) {
          //If page name is filled, then check page permission.
          (((((_vm.beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {})[options.type] || {})[options.module] || {})[options.page] = options.newValue;
        }
        if (!options.page) {
          // else not checked
          ((((_vm.beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {})[options.type] || {})[options.module] = options.newValue;
        }
        if (options.checkall) _vm.checkall(options.type, options.module, options.newValue);
        if (options.decheckall) _vm.decheckall(options.type, options.module, options.newValue);
        if (!options.newValue && options.type == 'read') {
          if (options.page) (((((_vm.beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[options.module] || {})[options.page] = options.newValue;
          if (!options.page) ((((_vm.beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[options.module] = options.newValue;
          if (options.checkall) _vm.checkall('edit', options.module, options.newValue);
          if (options.decheckall) _vm.decheckall('edit', options.module, options.newValue);
        }
        if (options.newValue && options.type == 'edit') {
          if (options.page) (((((_vm.beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[options.module] || {})[options.page] = options.newValue;
          if (!options.page) ((((_vm.beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[options.module] = options.newValue;
          if (options.checkall) _vm.checkall('read', options.module, options.newValue);
        }
      }
    }
  }), _vm._v(" "), _c('detach-neopass-popup', {
    attrs: {
      "is-displayed": _vm.beneficiary_out_display > -1,
      "state": _vm.beneficiary_out_display,
      "neopass-to-detach": _vm.neopassToDetach
    },
    on: {
      "close": _vm.closePopupDetachNeopass,
      "confirmDetach": function ($event) {
        return _vm.detachNeopass(_vm.neopassToDetach.id);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "relative hidden md:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden md:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "Group189"
    }
  })], 1), _vm._v(" "), _vm.allowed ? _c('div', {
    staticClass: "grid grid-cols-2 md:grid-cols-5 2xl:grid-cols-4 gap-4 mt-16 items-center mb-10"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE) ? _c('div', {
    staticClass: "col-start-1 col-span-1"
  }, [_c('action-button', {
    attrs: {
      "id": "add-neopass",
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER UN CARNET",
      "uppercase": true,
      "icon": "plus-circle",
      "responsive": false,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.openPopupNewNeopass
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.structures.length > 1 ? _c('div', {
    staticClass: "col-span-1"
  }, [_c('input-select', {
    attrs: {
      "name": "choice_structure",
      "value": _vm.structure,
      "datas": _vm.structures,
      "libelle": "",
      "empty-case": false,
      "value-is-object": true,
      "icon": "building"
    },
    on: {
      "input": function (newValue) {
        _vm.changeStructureAndReloadInfos(newValue.id);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-start-1 col-span-2 md:col-start-3 md:col-span-3 2xl:col-start-3 2xl:col-span-2 flex w-full space-x-5 items-center",
    attrs: {
      "id": "filter-name"
    },
    on: {
      "keydown": _vm.onKeyDown,
      "keyup": _vm.onKeyUp
    }
  }, [_c('search-bar', {
    attrs: {
      "name": "searchBeneficiary",
      "libelle": "",
      "value": _vm.search,
      "placeholder": "Rechercher un bénéficiaire",
      "big": false,
      "inherits": false,
      "has-border": false
    },
    on: {
      "input": function (newValue) {
        _vm.search = newValue;
      }
    }
  }), _vm._v(" "), _c('sort-button', {
    staticClass: "col-span-1 md:col-start-4 md:col-span-1 place-self-end",
    attrs: {
      "id": "filter-date",
      "sort": _vm.sort,
      "responsive": true
    },
    on: {
      "sorted": function (sortType) {
        _vm.changeSortType(sortType);
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), false ? _c('div', {
    staticClass: "col-start-1 col-span-full flex space-x-5 justify-end items-center mb-5"
  }, [_c('div', [_vm._v("Résultat par page")]), _vm._v(" "), _c('tag', {
    staticClass: "cursor-pointer",
    attrs: {
      "libelle": "10",
      "theme-color": _vm.perPage === 10 ? 'indigo' : 'white',
      "scale-on-hover": true
    },
    on: {
      "push": function ($event) {
        return _vm.changePerPage(10);
      }
    }
  }), _vm._v(" "), _c('tag', {
    staticClass: "cursor-pointer",
    attrs: {
      "libelle": "20",
      "theme-color": _vm.perPage === 20 ? 'indigo' : 'white',
      "scale-on-hover": true
    },
    on: {
      "push": function ($event) {
        return _vm.changePerPage(20);
      }
    }
  }), _vm._v(" "), _c('tag', {
    staticClass: "cursor-pointer",
    attrs: {
      "libelle": "50",
      "theme-color": _vm.perPage === 50 ? 'indigo' : 'white',
      "scale-on-hover": true
    },
    on: {
      "push": function ($event) {
        return _vm.changePerPage(50);
      }
    }
  }), _vm._v(" "), _c('tag', {
    staticClass: "cursor-pointer",
    attrs: {
      "libelle": "100",
      "theme-color": _vm.perPage === 100 ? 'indigo' : 'white',
      "scale-on-hover": true
    },
    on: {
      "push": function ($event) {
        return _vm.changePerPage(100);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.allowed ? _c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('list-grid', {
    attrs: {
      "list-items": _vm.neopass,
      "is-listdisplayed": _vm.neopass != null && _vm.neopass.length > 0
    },
    scopedSlots: _vm._u([_vm.neopass ? {
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-2 md:col-start-2 xl:col-start-2 xxl:col-start-2 col-span-8 md:col-span-3 xl:col-span-2 xxl:col-span-3 ml-8 md:ml-0 xxl:ml-8"
        }, [_vm._v("\n          Bénéficiaires\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-3 2xl:col-span-4"
        }, [_vm._v("\n          Droit d'accès\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-2 xl:col-span-3 xxl:col-span-2"
        }, [_vm._v("\n          Actions rapides\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 md:col-span-3 2xl:col-span-2 md:ml-5 lg:ml-0"
        }, [_vm._v("\n          Modifier "), _c('span', {
          staticClass: "hidden md:inline"
        }, [_vm._v("le carnet")])])];
      },
      proxy: true
    } : null, {
      key: "errorCases",
      fn: function () {
        return [_vm.neopass.length === 0 ? _c('div', {
          staticClass: "flex flex-col justify-center items-center w-full my-8"
        }, [_c('div', {
          staticClass: "text-pink-600 text-center text-lg mb-8"
        }, [_vm._v("\n            Aucun Neopass !\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "text-indigo-600 text-center text-base mb-8"
        }, [_vm._v("\n            Il n'y a aucun Neopass trouvé\n          ")]), _vm._v(" "), _c('div', [_c('illustration', {
          attrs: {
            "name": "no_result"
          }
        })], 1)]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('div', {
          staticClass: "hidden md:block item col-span-1 ml-8 md:ml-0 xxl:ml-8"
        }, [_c('profile-picture', {
          staticClass: "md:hidden xl:block",
          attrs: {
            "size": "max-w-8 w-8 h-8",
            "other-object": item
          }
        }), _vm._v(" "), _c('profile-picture', {
          staticClass: "hidden md:block xl:hidden",
          attrs: {
            "size": "max-w-6 w-6 h-6",
            "other-object": item
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-8 md:col-span-3 xl:col-span-2 xxl:col-span-3 ml-8 md:ml-0 xxl:ml-8 justify-self-start"
        }, [_c('div', [_c('p', {
          staticClass: "text-lg text-gray-900"
        }, [_vm._v("\n              " + _vm._s(item.firstname) + "\n              "), _c('span', {
          staticClass: "uppercase"
        }, [_vm._v(_vm._s(item.lastname))])]), _vm._v(" "), _c('p', {
          staticClass: "text-sm text-gray-900"
        }, [_vm._v("\n              Crée le\n              " + _vm._s(_vm._f("formatDate")(item.created_at.slice(0, 10))) + "\n            ")]), _vm._v(" "), _c('p', {
          staticClass: "text-sm text-gray-600 font-light"
        }, [_vm._v("\n              Mise à jour le\n              " + _vm._s(_vm._f("formatDate")(item.updated_at.slice(0, 10))) + "\n            ")])])]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:flex md:col-span-3 2xl:col-span-4 justify-self-start w-full"
        }, [item.referents && item.referents.length > 0 ? _c('div', {
          staticClass: "text-sm leading-5 text-gray-600 italic relative",
          on: {
            "mouseover": function ($event) {
              return _vm.displayListReferent(num);
            },
            "mouseleave": function ($event) {
              return _vm.displayListReferent(-1);
            }
          }
        }, [_c('transition', {
          attrs: {
            "enter-active-class": "duration-300",
            "enter-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "duration-300",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }
        }, [_vm.beneficiaryListReferentToDisplay == num ? _c('div', {
          staticClass: "absolute bg-indigo-600 text-white flex rounded-lg shadow-lg text-xs z-50 py-5 px-6 bottom-10 left-0 w-max-content w-max max-w-64 md:max-w-72 xxl:max-w-128"
        }, [_c('div', _vm._l(item.referents, function (referent, num) {
          return _c('p', {
            key: num
          }, [_vm._v("\n                    " + _vm._s(referent.firstname) + "\n                    "), _c('span', {
            staticClass: "uppercase"
          }, [_vm._v(_vm._s(referent.lastname))]), _vm._v(_vm._s(item.referents[++num] == undefined ? '' : ',') + "\n                  ")]);
        }), 0)]) : _vm._e()]), _vm._v(" "), _c('span', {
          staticClass: "font-semibold"
        }, [_vm._v("Référent"), item.referents.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v("\n            :\n            "), _c('div', {
          staticClass: "hidden line-clamp-3"
        }, _vm._l(item.referents, function (referent, num) {
          return _c('span', {
            key: num
          }, [_vm._v("\n                " + _vm._s(referent.firstname) + "\n                "), _c('span', {
            staticClass: "uppercase"
          }, [_vm._v(_vm._s(referent.lastname))]), _vm._v(_vm._s(item.referents[++num] == undefined ? '' : ',') + "\n              ")]);
        }), 0)], 1) : _c('div', {
          staticClass: "text-sm leading-5 text-gray-600 italic mr-10"
        }, [_vm._v("\n            Pas de référent\n          ")])]), _vm._v(" "), _c('div', {
          class: 'hidden md:flex md:col-span-2 xl:col-span-3 xxl:col-span-2 space-x-0.5 justify-self-start items-between text-orange-600 font-semibold ' + (_vm.index === 0 ? 'tour_quick_actions' : ''),
          attrs: {
            "id": _vm.index === 0 ? 'quick-actions' : ''
          }
        }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_PARAMETRES_DROITS_ACCES) ? _c('circle-button', {
          attrs: {
            "icon": "person",
            "label": "Modifier les droits d'accès du bénéficiaire"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.load_one_beneficiary_rights(item);
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "relative"
        }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('circle-button', {
          attrs: {
            "icon": "printer",
            "label": "Exporter/Imprimer"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.displayDropDownExport(item.id);
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-out duration-150",
            "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
            "leave-active-class": "ease-in duration-200",
            "leave-class": "opacity-100 translate-y-0 sm:scale-100",
            "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          }
        }, [_vm.dropDownExportMenu == item.id ? _c('div', {
          directives: [{
            name: "clickOutside",
            rawName: "v-clickOutside",
            value: _vm.forceHide,
            expression: "forceHide"
          }],
          staticClass: "dropDownExportMenu z-20 absolute left-0 top-8 mt-1 p-10 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
        }, [_c('h6', {
          staticClass: "mb-5 text-gray-900"
        }, [_vm._v("\n                  Quels modules voulez vous exporter ?\n                ")]), _vm._v(" "), _c('div', [_c('checkbox-indigo', {
          attrs: {
            "name": "allModule",
            "libelle": "Tout",
            "value": _vm.listModulesToExport.length == _vm.listNeopassModulesPages.length
          },
          on: {
            "input": function (newValue) {
              _vm.selectAllModuleToExport();
            }
          }
        }), _vm._v(" "), _vm._l(_vm.listNeopassModulesPages, function (mod, indexMod) {
          return _c('checkbox-indigo', {
            key: indexMod,
            staticClass: "ml-5",
            attrs: {
              "name": mod.name,
              "libelle": mod.display_name,
              "value": _vm.listModulesToExport.includes(mod.id)
            },
            on: {
              "input": function (newValue) {
                _vm.addModuleToExport(mod.id);
              }
            }
          });
        })], 2), _vm._v(" "), _vm.typeExportInProgress == '' ? _c('div', {
          staticClass: "mt-10 flex justify-center"
        }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-white",
            "bg-color": "bg-pink-600",
            "libelle": "Exporter en PDF"
          },
          on: {
            "clickAction": function ($event) {
              return _vm.exporter(item, 'neopass');
            }
          }
        }) : _vm._e()], 1) : _vm.typeExportInProgress == 'neopass' ? _c('div', {
          staticClass: "mt-10 flex justify-center"
        }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-white",
            "bg-color": "bg-pink-600",
            "libelle": "Export en cours",
            "spinner": true
          }
        }) : _vm._e()], 1) : _c('div', {
          staticClass: "mt-10 flex justify-center"
        }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-white",
            "bg-color": "bg-gray-600",
            "libelle": "Exporter en PDF"
          }
        }) : _vm._e()], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              name: 'Cartoindcompperso',
              params: {
                id: item.id
              }
            },
            "title": "Cartographies individuelles"
          }
        }, [_vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_DISPLAY) ? _c('circle-button', {
          attrs: {
            "icon": "bar-chart-2",
            "label": "Cartographies individuelles",
            "enable-click": false
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              name: 'UserHistory',
              params: {
                user: item.id
              }
            },
            "title": "Historique des mouvements"
          }
        }, [true ? _c('circle-button', {
          attrs: {
            "icon": "file-text",
            "label": "Historique des mouvements",
            "enable-click": false
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_NEOPASS_DETACHER) ? _c('circle-button', {
          attrs: {
            "icon": "log-out",
            "label": "Détacher le Neopass de la structure"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.openBeneficiaryDetachPopup(item.id);
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-3 md:col-span-3 2xl:col-span-2 md:ml-5 lg:ml-0 mr-0 md:mr-5 lg:mr-0"
        }, [_c('router-link', {
          staticClass: "w-auto",
          attrs: {
            "to": '/form/neopass/' + item.id
          }
        }, [_c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-gray-900",
            "bg-color": "bg-indigo-300",
            "bg-color-square": "bg-white",
            "icon-color": "text-indigo-600",
            "icon": "edit",
            "responsive": true,
            "libelle": "Modifier le carnet",
            "enable-action": false
          }
        })], 1)], 1)];
      }
    }], null, true)
  })], 1) : _c('page-not-allowed')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        Mes carnets de parcours\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 pr-48 xl:pr-72"
  }, [_vm._v("\n        Accompagner vos bénéficiaires dans la construction ou le maintien de\n        leurs projets personnels et professionnels."), _c('br'), _vm._v("\n        Vous pouvez éditer ou imprimer vos carnets de parcours.\n      ")])]);

}]

export { render, staticRenderFns }